module.exports = __webpack_public_path__ + "static/media/evenos-logo.044057ef.png";